/* eslint-disable */
import React, { useState } from "react";
import { Navigate, NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
// Chakra imports
import {
    Box,
    Button,
    Checkbox,
    Flex,
    FormControl,
    FormLabel,
    Heading,
    Icon,
    Input,
    InputGroup,
    InputRightElement,
    Text,
    Select,
    useColorModeValue,
    Spinner
} from "@chakra-ui/react";

import { GoogleLogin } from "@react-oauth/google";
import { GoogleOAuthProvider } from "@react-oauth/google";

import { notify } from "components/ToastNotification";
// Custom components
import { HSeparator } from "components/separator/Separator";
import DefaultAuth from "layouts/auth/Default";
// Assets
import illustration from "assets/img/auth/auth.png";
import { FcGoogle } from "react-icons/fc";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";
import { ENDPOINTS } from "utils/Constants";
import language from "react-syntax-highlighter/dist/esm/languages/hljs/1c";
import { AVAILABLE_LANGUAGES } from "utils/Constants";
import { GOOGLE_CLIENT_ID } from "utils/Constants";

function SignUp() {
    // Chakra color mode
    const navigate = useNavigate();
    const textColor = useColorModeValue("navy.700", "white");
    const textColorSecondary = "gray.400";
    const textColorDetails = useColorModeValue("navy.700", "secondaryGray.600");
    const textColorBrand = useColorModeValue("brand.500", "white");
    const [loading, setLoading] = useState(false);

    const brandStars = useColorModeValue("brand.500", "brand.400");
    const googleBg = useColorModeValue("secondaryGray.300", "whiteAlpha.200");
    const googleText = useColorModeValue("navy.700", "white");
    const googleHover = useColorModeValue(
        { bg: "gray.200" },
        { bg: "whiteAlpha.300" }
    );
    const googleActive = useColorModeValue(
        { bg: "secondaryGray.300" },
        { bg: "whiteAlpha.200" }
    );
    const [show, setShow] = React.useState(false);
    const [showRetypePass, setShowRetypePass] = React.useState(false)
    const handleClick = () => setShow(!show);
    const handleClickForRetype = () => setShowRetypePass(!showRetypePass);

    const [formData, setFormData] = React.useState({
        fullName: "",
        username: "",
        email: "",
        password: "",
        repeatPassword: "",
        language: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        const emptyFields = Object.keys(formData).filter((key) => !formData[key].trim());
        if (emptyFields.length > 0) {
            notify(`Please fill in all fields: ${emptyFields.join(", ")}`, "warning");
            setLoading(false)
            return;
        }

        if (formData.password !== formData.repeatPassword) {
            notify("Passwords do not match!", 'warning')
            return;
        }

        try {
            const response = await axios.post(ENDPOINTS.SIGNUP, formData);
            console.log("Response:", response.data);
            const responseData = response.data;
            notify(responseData.output, responseData.success ? 'success' : 'error');
            if (responseData.success) {
                navigate('/auth/sign-in');
            }
        } catch (error) {

            if (error.response?.data) {
                const response = error.response?.data;

                if (response?.errors) {
                    response?.errors.map(error => {
                        notify(error.msg, 'error');
                    })
                }

                if (response?.output) notify(response.output, 'error')


            }
        } finally {
            setLoading(false)
        }
    };

    const handleGoogleSignUpSuccess = async (credentialResponse) => {
        try {
            setLoading(true);
            const response = await axios.post(ENDPOINTS.GOOGLE_SIGNIN, {
                token: credentialResponse.credential,
            });
            const responseData = response.data;
            notify(responseData.output, responseData.success ? "success" : "error");
            if (responseData.success) {
                localStorage.setItem("currentUser", JSON.stringify(responseData.data));
                localStorage.setItem("token", responseData.data.token);
                window.location.href = '/admin';
            }
        } catch (error) {
            notify(error.response?.data?.output || "Google Login Failed", "error");
        } finally {
            setLoading(false);
        }
    }



    return (
        <DefaultAuth illustrationBackground={illustration} image={illustration}>
            <Flex
                maxW={{ base: "100%", md: "max-content" }}
                w='100%'
                mx={{ base: "auto", lg: "0px" }}
                me='auto'
                h='100%'
                alignItems='start'
                justifyContent='center'
                mb={{ base: "30px", md: "60px" }}
                px={{ base: "25px", md: "0px" }}
                mt={{ base: "40px", md: "14vh" }}
                flexDirection='column'>
                <Box me='auto'>
                    <Heading color={textColor} fontSize='36px' mb='10px'>
                        Sign Up
                    </Heading>
                    <Text
                        mb='36px'
                        ms='4px'
                        color={textColorSecondary}
                        fontWeight='400'
                        fontSize='md'>
                        Enter your credentials to Sign Up!
                    </Text>
                </Box>
                <Flex
                    zIndex='2'
                    direction='column'
                    w={{ base: "100%", md: "420px" }}
                    maxW='100%'
                    background='transparent'
                    borderRadius='15px'
                    mx={{ base: "auto", lg: "unset" }}
                    me='auto'
                    mb={{ base: "20px", md: "auto" }}>
                    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
                        <GoogleLogin
                            onSuccess={handleGoogleSignUpSuccess}
                            onError={() => notify("Google Signup Failed", "error")}
                            text="signup_with"
                        />
                    </GoogleOAuthProvider>
                    <Flex align='center' mb='25px'>
                        <HSeparator />
                        <Text color='gray.400' mx='14px'>
                            or
                        </Text>
                        <HSeparator />
                    </Flex>
                    <form onSubmit={handleSubmit}>
                        <FormControl>
                            <Flex direction="row" justify={'space-between'} gap={'16px'}>
                                <Input
                                    isRequired={true}
                                    variant='auth'
                                    fontSize='sm'
                                    ms={{ base: "0px", md: "0px" }}
                                    type='text'
                                    placeholder='Full Name*'
                                    mb='24px'
                                    fontWeight='500'
                                    size='lg'
                                    name="fullName"
                                    value={formData.fullName}
                                    onChange={handleChange}
                                />
                                <Input
                                    isRequired={true}
                                    variant='auth'
                                    fontSize='sm'
                                    ms={{ base: "0px", md: "0px" }}
                                    type='text'
                                    placeholder='Username*'
                                    mb='24px'
                                    fontWeight='500'
                                    size='lg'
                                    name="username"
                                    value={formData.username}
                                    onChange={handleChange}
                                />
                            </Flex>
                            <Input
                                isRequired={true}
                                variant='auth'
                                fontSize='sm'
                                ms={{ base: "0px", md: "0px" }}
                                type='email'
                                placeholder='Email*'
                                mb='24px'
                                fontWeight='500'
                                size='lg'
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                            />
                            <Flex direction="row" justify={'space-between'} gap={'16px'}>

                                <InputGroup size='md'>
                                    <Input
                                        isRequired={true}
                                        fontSize='sm'
                                        placeholder='Password*'
                                        mb='24px'
                                        size='lg'
                                        type={show ? "text" : "password"}
                                        variant='auth'
                                        name="password"
                                        value={formData.password}
                                        onChange={handleChange}
                                    />
                                    <InputRightElement display='flex' alignItems='center' mt='4px'>
                                        <Icon
                                            color={textColorSecondary}
                                            _hover={{ cursor: "pointer" }}
                                            as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                                            onClick={handleClick}
                                        />
                                    </InputRightElement>
                                </InputGroup>

                                <InputGroup size='md'>
                                    <Input
                                        isRequired={true}
                                        fontSize='sm'
                                        placeholder='Repeat Password*'
                                        mb='24px'
                                        size='lg'
                                        type={showRetypePass ? "text" : "password"}
                                        variant='auth'
                                        name="repeatPassword"
                                        value={formData.repeatPassword}
                                        onChange={handleChange}
                                    />
                                    <InputRightElement display='flex' alignItems='center' mt='4px'>
                                        <Icon
                                            color={textColorSecondary}
                                            _hover={{ cursor: "pointer" }}
                                            as={showRetypePass ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                                            onClick={handleClickForRetype}
                                        />
                                    </InputRightElement>
                                </InputGroup>
                            </Flex>
                            <FormControl mb="24px">
                                <Select
                                    name="language"
                                    value={formData.language}
                                    onChange={handleChange}
                                    style={{
                                        width: "100%",
                                        height: "40px",
                                        padding: "5px",
                                        fontSize: "14px",
                                    }}
                                >
                                    <option value="" disabled>
                                        Select Learning Language
                                    </option>
                                    {AVAILABLE_LANGUAGES.map((lang) => (
                                        <option key={lang} value={lang}>
                                            {lang}
                                        </option>
                                    ))}
                                </Select>
                            </FormControl>
                            <Button
                                type="submit"
                                fontSize='sm'
                                variant='brand'
                                fontWeight='500'
                                w='100%'
                                h='50'
                                mb='24px'>
                                {loading ? <Spinner size="sm" /> : "Sign Up"}
                            </Button>
                        </FormControl>
                    </form>
                    <Flex
                        flexDirection='column'
                        justifyContent='center'
                        alignItems='start'
                        maxW='100%'
                        mt='0px'>
                        <Text color={textColorDetails} fontWeight='400' fontSize='14px'>
                            Already have an account?
                            <NavLink to='/auth/sign-in'>
                                <Text
                                    color={textColorBrand}
                                    as='span'
                                    ms='5px'
                                    fontWeight='500'>
                                    Log In
                                </Text>
                            </NavLink>
                        </Text>
                    </Flex>
                </Flex>
            </Flex>
        </DefaultAuth>
    );
}

export default SignUp;
